export default __webpack_public_path__ + "static/media/yourturn-yellow.7460c421.png";